<style scoped>
@import '../../assets/css/topbar.css';
</style>

<template>
<div>
    <nav class="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top">
        <div class="container-fluid">
            <div class="navbar-wrapper">
                <a class="navbar-brand">{{$t($route.name)}}</a>
            </div>
            <div class="d-flex navbar-brand">
                <el-dropdown trigger="click" class="mr-5">
                    <span class="el-dropdown-link">
                        <font-awesome-icon icon="globe-asia"/> {{$t('general.language')}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="m-0">
                        <el-dropdown-item href="javascript:void(0);" v-for="(thisLanguage,key) in languageList" @click.native="switch_language(thisLanguage.code)" :key="key">{{thisLanguage.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                        {{username}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="m-0">
                        <el-dropdown-item><i class="dripicons-user text-muted"></i>{{$t('button.profile')}}</el-dropdown-item>
                        <el-dropdown-item divided @click.native="logoutSystem()"><i class="dripicons-exit text-muted"></i>{{$t('button.logout')}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <button class="navbar-toggler" id="navbar-inline" type="button" @click="show_nav()" data-toggle="collapse" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="navbar-toggler-icon icon-bar"></span>
                    <span class="navbar-toggler-icon icon-bar"></span>
                    <span class="navbar-toggler-icon icon-bar"></span>
                </button>
            </div>
        </div>
    </nav>
</div>
</template>

<script>
import {logout} from '@/system/model/auth';
import {getLocalStorage,setLocalStorage} from '@/system/store/localstorage';
import {removeTokenByName} from '@/system/store/cookie';

export default {
    inject:['preloader'],
    data(){
        return{
            languageList:[],
            username:''
        }
    },methods:{
        show_nav(){
            var root = document.getElementsByTagName( 'html' )[0];
            var toggled = document.getElementById('navbar-inline');
            var hasClass = document.getElementsByClassName('toggled')
            if(hasClass.length > 0){
                root.removeAttribute('class');
                toggled.classList.remove("toggled")
            }else{
                root.setAttribute( 'class', 'myCssClass' );
                root.className += ' perfect-scrollbar-on nav-open';
                toggled.className += ' toggled';
            }
        },switch_language(selectLang){
            setLocalStorage('currentLang', selectLang);
			this.$i18n.locale = selectLang;
            location.reload();
        },logoutSystem() {
			// removeTokenByName('auth_sign_token');
            this.$swal({
            text: this.$t('msg.alert_logout'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: this.$t('button.confirm'),
            cancelButtonText: this.$t('button.cancel'),
            }).then((result)=>{
                if(result.value){
                    var self = this;
                    self.preloader(true);
                    var result = logout();		
                    result.then(function(value){
                        if(value.valid){
                            self.$router.push('/');
                        }else{
                            self.preloader(false);
                            var text = "";
                            if(Array.isArray(value.returnMsg)){
                                value.returnMsg.forEach(function (value) {
                                    text += self.$t(value)+"<br />";
                                }); 
                            }else{
                                text = self.$t(value.returnMsg);
                            }

                            self.$swal.fire({
                                type: 'error',
                                html: text,
                                onClose: () => {
                                    self.preloader(false);
                                    location.reload();
                                }
                            });
                        }
                    });
                }
            });
        }
    },created:function(){
        this.preloader(false)
        var root = document.getElementsByTagName( 'html' )[0];    
        root.removeAttribute('class');
        this.languageList = JSON.parse(getLocalStorage('language_list'));
		this.username = getLocalStorage('username');
    }
}
</script>
